import {
  AggregatorPaymentSystems,
  WithdrawalsDistributionSettingsItems,
} from '@types';

import { WithdrawalsReceiveGetDistributionSettingsListReducer } from './types';

export const withdrawalsReceiveGetDistributionSettingsListReducer: WithdrawalsReceiveGetDistributionSettingsListReducer =
  (state, action) => {
    const { items } = action.payload;

    const withdrawalsDistributionSettingsItems = items.reduce(
      (previousValue, currentValue) => {
        return {
          ...previousValue,
          [currentValue.id]: {
            aggregatorState: currentValue.state,
            paymentSystems: currentValue.paymentSystems.reduce(
              (previousValue, currentValue) => {
                return currentValue
                  ? {
                      ...previousValue,
                      [currentValue.id]: {
                        paymentSystemState: currentValue.state,
                        distributionPercent: currentValue.distributionPercent,
                      },
                    }
                  : previousValue;
              },
              {} as AggregatorPaymentSystems
            ),
          },
        };
      },
      {} as WithdrawalsDistributionSettingsItems
    );

    return {
      ...state,
      withdrawalsDistributionSettingsItems,
    };
  };
